@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes"
      (click)="item.function()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="item.function()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="item.function()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
      </span>
    }
    @if (item.badgeCompartilhada) {
      <span class="nav-link-badge-shares" matTooltip="Compartilhadas"
        [ngStyle]="{'background-color': item.badgeCompartilhada.badge.bg,'color': item.badgeCompartilhada.badge.fg}">
        {{item.badgeCompartilhada.badge.title}}
      </span>
    }
  </ng-template>
}
